import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: 'app-upgrade-required',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './upgrade-required.component.html'
})
export class UpgradeRequiredComponent {
    ngOnInit() {
        console.log('Upgrade required');
        setTimeout(() => {
            this.reload();
        }, 15000);
    }

    async reload() {
        await this.unregisterServiceWorker();
        window.location.reload();
    }

    async unregisterServiceWorker() {
        if (navigator.serviceWorker) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            registrations.forEach(registration => {
                registration.unregister();
            });
        }
    }
}
